import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import pl from "./assets/lang/pl.json";
import en from "./assets/lang/en.json";

export const LANGUAGES = [
  {
    name: "Polski",
    lang: "pl",
    locale: "pl-PL",
  },
  {
    name: "English",
    lang: "en",
    locale: "en-GB",
  },
];

export const getInitialLang = () => {
  const deviceLanguage = navigator.language || navigator.userLanguage;
  const defaultLang = LANGUAGES.find(({ locale }) => locale === deviceLanguage);
  console.log(deviceLanguage, defaultLang)
  return defaultLang?.locale || "en-GB";
};
i18n.use(initReactI18next).init({
  resources: {
    "pl-PL": {
      translation: pl,
    },
    "en-GB": {
      translation: en,
    },
  },
  lng: getInitialLang(),

  keySeparator: false,

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
